export default __webpack_public_path__ + "7b3f7dd9aa09860d5cc888ffe89e7945.svg";